import { errorAlert } from 'cadenza/alert';
import { cadenzaUrl } from 'cadenza/utils/cadenza-url/cadenza-url';

import { ajax } from 'cadenza/api-client/api';
import i18n from 'cadenza/api-client/messages.properties';
import type { ViewId } from 'cadenza/workbook/api/view-id';

/**
 * Activates a view with the give id.
 * Fails when there is no view with that id.
 *
 * @param viewId - The id of the view to activate
 * @return Promise
 */
function activate (viewId: ViewId) {
  return ajax<void>(`/view?viewId=${viewId}`, { method: 'PUT' });
}

export function setupViewActivation (viewId: ViewId, redirectInvalidToWelcome: boolean) {
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && document.getElementsByClassName('alert-dialog').length === 0) {
      activate(viewId).catch(() => {
        const message = redirectInvalidToWelcome
          ? i18n('view.activate.exception.redirectToWelcome.message')
          : i18n('view.activate.exception.reload.message');
        return errorAlert(i18n('view.activate.exception.title'), message)
          .finally(() => {
            if (redirectInvalidToWelcome) {
              location.href = cadenzaUrl('/');
            } else {
              location.reload();
            }
          });
      });
    }
  });
}
